import style from './index.module.scss'
import { useEffect, useState } from 'react'
import { Rnd } from 'react-rnd'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
import t4bFrame from '../../assets/icons/tfbFrame.svg'
import { changeUserSurveyStatus } from '../../store/async-thunks/homePage/changeSurveyStatus'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { Survey } from '../../types/survey'
import { FormattedMessage } from 'react-intl'
import { BDropdown } from '../overlays/BDropdown/BDropdown'

const modalWidth = 450
const modalHeight = 240
const delta = 100

interface SurveyPopupProps {
    survey: Survey
    onSurveyAccept: (flag: boolean) => void
    onSurveyClose: () => void
}

export const SurveyPopup = (props: SurveyPopupProps) => {
    const { survey, onSurveyAccept, onSurveyClose } = props
    const dispatch = useAppDispatch()
    const [position, setPosition] = useState(getModalPosition())

    const itemsList = [
        {
            name: 'homePage.reject',
            action: declineSurvey,
        },
        {
            name: 'homePage.dontShow3days',
            action: postponeSurvey,
        },
    ]

    function declineSurvey() {
        dispatch(changeUserSurveyStatus(survey.survey_id, 'declined'))
        onSurveyClose()
    }

    function postponeSurvey() {
        dispatch(changeUserSurveyStatus(survey.survey_id, 'postponed'))
        onSurveyClose()
    }

    const acceptSurvey = () => {
        onSurveyAccept(true)
    }

    function getModalPosition() {
        return {
            x: window.innerWidth - modalWidth - delta,
            y: window.innerHeight - modalHeight - delta,
        }
    }

    useEffect(() => {
        const handleResize = () => {
            setPosition(getModalPosition())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <Rnd
            size={{ width: modalWidth, height: modalHeight }}
            position={position}
            enableResizing={false}
            disableDragging={true}
            bounds="window"
            style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                zIndex: 10000,
                display: 'flex',
                flexDirection: 'column',
                cursor: 'default',
                padding: '24px 32px',
                gap: '8px',
            }}
        >
            <div className="d-flex justify-content-between align-items-center">
                <img
                    src={t4bFrame}
                    alt="tfb frame"
                />
                <BDropdown
                    tooltip={''}
                    drop="up"
                    dropdownItems={itemsList}
                    dropdownToggle={
                        <FontAwesomeIcon
                            className={style.btn}
                            icon={faXmark}
                        />
                    }
                />
            </div>
            <h5 className={`mt-2 ${style.surveyTitle}`}>{survey.title}</h5>
            <FormattedMessage id={'homePage.surveyPopupMsg'} />
            <Button
                className="app-btn-main app-btn-apply mt-3"
                onClick={acceptSurvey}
            >
                <FormattedMessage id={'homePage.openSurvey'} />
            </Button>
        </Rnd>
    )
}
